import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.ReportsRequestPage.PopupPrintPreviewWindow.ContentScreen', {
    reportNameHeaderText: '"{reportName}" Report',
});
